(function () {
  const replacements = {
    '3d developer displays': 'Light Field Displays',
    'digital signage': 'Hololuminescent Displays',
    'hololuminescent displays overview': 'HLD Overview',
  };

  const checkoutBase = 'https://checkout.lookingglassfactory.com';
  const linkTargets = {
    'hololuminescent displays': 'https://lookingglassfactory.com/hld-overview',
    'hld overview': 'https://lookingglassfactory.com/hld-overview',
    'hld 16"': '/products/hld-displays-early-access',
    'hld 27"': '/products/hld-displays-early-access',
    'hld 86"': '/products/hld-86',
    musubi: 'https://look.glass/musubi',
    'light field displays': 'https://lookingglassfactory.com/displays-overview',
    'lfd overview': 'https://lookingglassfactory.com/displays-overview',
    '6" light field developer kit (lkg go)': '/products/looking-glass-go',
    '16" light field display': '/products/16-lightfield-display',
    '27" light field display': '/products/27-lightfield-display',
  };

  let queued = false;

  function textOf(node) {
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function keyOf(node) {
    return textOf(node).replace(/[“”″]/g, '"').toLowerCase();
  }

  function closestItem(node) {
    return node.closest('.gm-item, li');
  }

  function labelForItem(item) {
    const label = item ? item.querySelector('.gm-text, a, span') : null;
    return label ? keyOf(label) : '';
  }

  function linkForItem(item) {
    return item ? item.querySelector('a[href]') : null;
  }

  function targetForLabel(label) {
    if (label.includes('musubi')) {
      return 'https://look.glass/musubi';
    }

    return linkTargets[label];
  }

  function sectionBefore(item) {
    let current = item ? item.previousElementSibling : null;

    while (current) {
      const label = labelForItem(current);

      if (label === 'light field displays' || label === '3d developer displays') {
        return 'Light Field Displays';
      }

      if (label === 'hololuminescent displays' || label === 'digital signage') {
        return 'Hololuminescent Displays';
      }

      current = current.previousElementSibling;
    }

    return '';
  }

  function revealSectionItems(item) {
    let current = item ? item.nextElementSibling : null;

    while (current) {
      const label = labelForItem(current);

      if (
        label === 'light field displays' ||
        label === '3d developer displays' ||
        label === 'hololuminescent displays' ||
        label === 'digital signage'
      ) {
        break;
      }

      current.classList.toggle('open', current.classList.contains('for_hide'));
      current = current.nextElementSibling;
    }
  }

  function updateLabel(label) {
    const current = keyOf(label);
    const replacement = replacements[current];

    if (replacement) {
      label.textContent = replacement;

      if (replacement === 'Light Field Displays' || replacement === 'Hololuminescent Displays') {
        const item = closestItem(label);
        if (item) {
          item.classList.add('lkg-no-toggle');
          item.classList.remove('accordian_tab');
          revealSectionItems(item);
        }
      }

      return;
    }

    if (current === 'overview' && sectionBefore(closestItem(label)) === 'Light Field Displays') {
      label.textContent = 'LFD Overview';
    }
  }

  function tuneProductsMenu(menu) {
    const items = Array.from(menu.querySelectorAll('.gm-item, li'));
    const hld86 = items.find((item) => labelForItem(item).includes('hld 86'));
    const musubi = items.find((item) => labelForItem(item).includes('musubi'));

    items.forEach((item) => {
      const label = labelForItem(item);
      const link = linkForItem(item);
      const target = targetForLabel(label);

      item.classList.remove('lkg-feature-row');
      item.classList.toggle('lkg-hide-menu-item', label === 'featured');

      if (link && target) {
        link.href = target.startsWith('http') ? target : checkoutBase + target;
        link.removeAttribute('target');
        link.removeAttribute('rel');
      }
    });

    if (hld86 && musubi && hld86.nextElementSibling !== musubi) {
      hld86.insertAdjacentElement('afterend', musubi);
    }
  }

  function forceTopLevelNavRow() {
    document.querySelectorAll('.header__inline-menu .gm-menu').forEach((menu) => {
      if (menu.closest('.gm-submenu')) return;

      const topLevelItems = Array.from(menu.children).filter((item) => item.classList.contains('gm-level-0'));
      const compactHeader = window.matchMedia('(max-width: 1120px)').matches;

      menu.style.setProperty('display', 'flex', 'important');
      menu.style.setProperty('align-items', 'center', 'important');
      menu.style.setProperty('flex-wrap', 'nowrap', 'important');
      menu.style.setProperty('gap', compactHeader ? '24px' : '32px', 'important');
      menu.style.setProperty('width', 'max-content', 'important');
      menu.style.setProperty('min-width', '0', 'important');
      menu.style.setProperty('max-width', 'none', 'important');
      menu.style.setProperty('white-space', 'nowrap', 'important');

      topLevelItems.forEach((item) => {
        item.style.setProperty('display', 'inline-flex', 'important');
        item.style.setProperty('flex', '0 0 auto', 'important');
        item.style.setProperty('width', 'auto', 'important');
        item.style.setProperty('min-width', '0', 'important');
        item.style.setProperty('margin-right', '0', 'important');
        item.style.setProperty('white-space', 'nowrap', 'important');

        const target = item.querySelector(':scope > .gm-target, :scope > a');
        if (target) {
          target.style.setProperty('display', 'inline-flex', 'important');
          target.style.setProperty('align-items', 'center', 'important');
          target.style.setProperty('width', 'auto', 'important');
          target.style.setProperty('min-width', '0', 'important');
          target.style.setProperty('padding', '0', 'important');
          target.style.setProperty('white-space', 'nowrap', 'important');
        }
      });
    });
  }

  function updateMenu() {
    document.querySelectorAll('.gm-menu .gm-text, .gm-submenu .gm-text').forEach(updateLabel);
    document.querySelectorAll('.gm-submenu, .gm-menu').forEach(tuneProductsMenu);
    forceTopLevelNavRow();
  }

  function scheduleUpdate() {
    if (queued) return;
    queued = true;

    window.requestAnimationFrame(function () {
      queued = false;
      updateMenu();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateMenu();

    new MutationObserver(scheduleUpdate).observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(updateMenu, 600);
    window.setTimeout(updateMenu, 1200);
    window.setTimeout(updateMenu, 2500);
    window.addEventListener('resize', scheduleUpdate);
  });
})();
